import { encodeOpts } from '@/utils/encode-opts';

const orderProgressStepsApiFactory = (axios) => ({
  getOrderProgressSteps: async (params) =>
    (await axios.get(`order-progress-steps`, { params, paramsSerializer: encodeOpts })).data,
});

export { orderProgressStepsApiFactory };
